import { Navigate, useRoutes } from "react-router-dom";
// layouts
import DashboardLayout from "./layouts/dashboard";
import SimpleLayout from "./layouts/simple";
//;
import GamePage from "./pages/GamePage";
import LoginPage from "./pages/LoginPage";
import Page404 from "./pages/Page404";
import DashboardAppPage from "./pages/DashboardAppPage";
import PickemEditPage from "./pages/PickemEditPage";
import PickemQuestinPage from "./pages/PickemQuestionPage";
import ImageLibraryPage from "./pages/ImageLibraryPage";
import BannersPage from './pages/BannersPage';
import LoginToastPage from './pages/LoginToastPage';
import LeaderboardsPage from "./pages/LeaderboardsPage";
import LeaderboardPage from "./pages/LeaderboardPage";
import UserSelectionsPage from "./pages/UserSelectionsPage";
import LeaguesPage from "./pages/LeaguesPage";
import LeagueTournamentsPage from "./pages/LeagueTournamentsPage";
import PlayersStatsPage from "./pages/PlayersStatsPage";
import FriendsLeaguePage from "./pages/FriendsLeaguePage";
import FixturesGoaliePage from "./pages/FixturesGoaliePage";
import PagesList from "./pages/PagesList";
import PageEditPage from "./pages/PageEditPage";
import SettingsPage from "./pages/SettingsPage";

import PrizeDrawsPage from "./pages/PrizeDrawsPage";
import PrizeDrawAddPage from "./pages/PrizeDrawAddPage";
import ParticipantTableList from "./pages/ParticipantTableList";
import TicketTransactionsPage from "./pages/TicketTransactionsPage";
import UsersPage from "./pages/Users";
import UserDetailsPage from "./pages/UserDetailsPage";
import NotificationsPage from "./pages/NotificationsPage";

// ----------------------------------------------------------------------

export default function Router() {
  const routes = useRoutes([
    {
      path: "/dashboard",
      element: <DashboardLayout />,
      children: [
        { element: <Navigate to="/dashboard/pickems" />, index: true },
        { path: "pickems", element: <GamePage /> },
        { path: "pages", element: <PagesList /> },
        { path: "pages/edit", element: <PageEditPage /> },
        { path: "image-library", element: <ImageLibraryPage /> },
        { path: "banners", element: <BannersPage /> },
        { path: "settings", element: <SettingsPage /> },
        { path: "login-toast", element: <LoginToastPage /> },
        { path: "leaderboards", element: <LeaderboardsPage /> },
        { path: "leaderboards/view", element: <LeaderboardPage /> },
        { path: "user-selections", element: <UserSelectionsPage /> },
        { path: "leagues", element: <LeaguesPage /> },
        { path: "friends-leagues", element: <FriendsLeaguePage /> },
        { path: "league-tournaments", element: <LeagueTournamentsPage /> },
        { path: "pickem/edit", element: <PickemEditPage /> },
        { path: "pickem/question", element: <PickemQuestinPage /> },
        { path: "stats", element: <PlayersStatsPage /> },
        { path: "fixtures-squad", element: <FixturesGoaliePage /> },
        { path: "app", element: <DashboardAppPage /> },

        { path: "prize-draws", element: <PrizeDrawsPage /> },
        { path: "prize-draws/add", element: <PrizeDrawAddPage /> },
        {
          path: "prize-draws/:raffleId/participants",
          element: <ParticipantTableList />,
        },
        {
          path: "prize-draws/:raffleId/prizes",
          element: <ParticipantTableList />,
        },

        { path: "ticket-transactions", element: <TicketTransactionsPage /> },
        { path: "users", element: <UsersPage /> },
        { path: "user/:userId", element: <UserDetailsPage /> },
        { path: "pickems/:id/user-selections/:user_id", element: <UserSelectionsPage /> },
        { path: "notifications", element: <NotificationsPage /> }
      ],
    },
    {
      path: "login",
      element: <LoginPage />,
    },
    {
      element: <SimpleLayout />,
      children: [
        { element: <Navigate to="/dashboard/pickems" />, index: true },
        { path: "404", element: <Page404 /> },
        { path: "*", element: <Navigate to="/404" /> },
      ],
    },
    {
      path: "*",
      element: <Navigate to="/404" replace />,
    },
  ]);

  return routes;
}
